import { render, staticRenderFns } from "./FedExButton.vue?vue&type=template&id=66a10dc4&scoped=true&"
var script = {}
import style0 from "./FedExButton.vue?vue&type=style&index=0&id=66a10dc4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a10dc4",
  null
  
)

export default component.exports